import { render, staticRenderFns } from "./Quick.vue?vue&type=template&id=6eda1bbd&scoped=true"
import script from "./Quick.vue?vue&type=script&lang=js"
export * from "./Quick.vue?vue&type=script&lang=js"
import style0 from "./Quick.vue?vue&type=style&index=0&id=6eda1bbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eda1bbd",
  null
  
)

export default component.exports